import { ExternalLinkUrl } from 'config/shared/types/links';
import settings from 'services/app-settings';

export const resolveExternalLinkUrl = (externalLinkUrl: ExternalLinkUrl): string => {
  const env = settings.app.env;

  return externalLinkUrl[env as keyof ExternalLinkUrl] || externalLinkUrl.default || '';
};
